import { useMemo, useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { coldFacts } from '@/mocks/home';

export default function ColdFacts() {
  const filters = useMemo(() => {
    const set = new Set(coldFacts.map((fact) => fact.category));
    return ['全部', ...Array.from(set)];
  }, []);
  const [active, setActive] = useState('全部');

  const list = active === '全部' ? coldFacts : coldFacts.filter((fact) => fact.category === active);

  return (
    <section id="facts" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="围观冷知识"
            title="聊天时随手能用的冷门知识"
            desc="关于八卦、传播和记忆的一些小结论，看完你会发现，吃瓜这件事比想象中更有学问。"
          />
          <div className="flex flex-wrap gap-2">
            {filters.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => setActive(tag)}
                className={`px-4 py-2 rounded-full text-sm transition-colors whitespace-nowrap ${
                  active === tag
                    ? 'bg-foreground-900 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900'
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {list.map((fact, index) => (
            <article
              key={fact.id}
              className="flex items-start gap-4 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="w-14 h-14 flex-shrink-0 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-bookmark-3-line text-2xl" />
              </span>
              <div>
                <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                  {fact.category}
                </span>
                <p className="mt-2.5 text-sm md:text-base leading-relaxed text-foreground-800">
                  <strong className="font-heading text-accent-600 mr-1">{index + 1}.</strong>
                  {fact.text}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}